import React from "react";
import { aboutImage } from "../mock";
import { CheckCircle2 } from "lucide-react";
import { Button } from "./ui/button";

const points = [
  "Industry-experienced trainers & recruiters",
  "End-to-end BPO & talent acquisition support",
  "Placements across IT, Non-IT, and Healthcare",
  "Corporate training tailored to your goals",
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[5/6] max-w-md">
            <img src={aboutImage} alt="Lead Matrix team" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-brand text-white rounded-2xl p-6 shadow-xl max-w-[220px]">
            <div className="font-display text-4xl font-bold">12+</div>
            <div className="text-sm text-white/90 mt-1">Years of empowering talent & businesses</div>
          </div>
          <div className="hidden md:block absolute -top-6 -left-6 w-32 h-32 rounded-full border-4 border-brand/20" />
        </div>

        <div>
          <div className="section-label mb-4">About Us</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-gray-900 leading-tight spaced-heading">
            Empowering <span className="text-brand">Talent</span>,<br /> Transforming Businesses
          </h2>
          <p className="mt-5 text-gray-600 leading-relaxed">
            Lead Matrix Business Solutions delivers expert recruitment, corporate training, career development, and BPO services—bridging the gap between skilled professionals and top-tier companies across IT, Non-IT, and Healthcare sectors.
          </p>
          <ul className="mt-7 grid sm:grid-cols-2 gap-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-gray-800">
                <CheckCircle2 className="text-brand shrink-0 mt-0.5" size={18} />
                <span>{p}</span>
              </li>
            ))}
          </ul>
          <Button asChild className="mt-8 bg-brand hover:bg-brand-dark text-white rounded-full h-12 px-7">
            <a href="#contact">Read more</a>
          </Button>
        </div>
      </div>
    </section>
  );
}
